import { Stack, TableCell } from '@mui/material';
import { ILanguage, filedGroupItemDataType } from 'constants/content.constants';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { getLanguages, getCurrentData, updateCurrentData } from 'state/reducers/content.reducers';
import { TextInput } from '../Inputs';
import { isSendExampleEmailContext } from 'pages/ContentApp';
import { useContext } from 'react';

interface IProps {
	item: any;
	selectedLanguage?: string;
}

export const TextInputTableCell = ({ item, selectedLanguage }: IProps) => {
	const dispatch = useAppDispatch();
	const languages = useAppSelector(getLanguages);
	const currentData = useAppSelector(getCurrentData);
	const currentItem = currentData.filter((element: any) => element.id === item.id)[0];
	const { isSendExampleEmail, onChangeEmailFields } = useContext(isSendExampleEmailContext);

	const updateData = (dataType: string, text: string, languageCode: string, itemId: number) => {
		if (isSendExampleEmail) {
			onChangeEmailFields(itemId, text);
		}
		dispatch(
			updateCurrentData({
				dataType,
				data: { text, languageCode },
				itemId,
			})
		);
	};

	return (
		<TableCell data-key={currentItem?.key}>
			{selectedLanguage ? (
				<TextInput
					value={currentItem[selectedLanguage]}
					inputstyle={currentItem.boStyle}
					label=""
					onChange={(text: string) =>
						updateData(filedGroupItemDataType.TEXT, text, selectedLanguage, currentItem.id)
					}
				/>
			) : (
				<>
					<Stack spacing={2}>
						{languages?.map((language: ILanguage, index: number) => {
							return (
								<TextInput
									key={index}
									disabled={currentItem?.boStyle === 'disabled'}
									value={currentItem ? currentItem[language.code] : ''}
									inputstyle={currentItem.boStyle}
									label=""
									onChange={(text: string) =>
										updateData(filedGroupItemDataType.TEXT, text, language.code, currentItem.id)
									}
								/>
							);
						})}
					</Stack>
				</>
			)}
		</TableCell>
	);
};
